import { render, staticRenderFns } from "./petientWriteModal.vue?vue&type=template&id=58a859a2"
import script from "./petientWriteModal.vue?vue&type=script&lang=js"
export * from "./petientWriteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports